import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CommonApiService } from 'src/helper/common-api.service';
import { StaticDataApiService } from 'src/helper/static-data.service';

@Component({
  selector: 'app-itim',
  templateUrl: './itim.component.html',
  styleUrls: ['./itim.component.css']
})
export class ItimComponent implements OnInit {
  module: string;
  module2: string;
  header: string;
  paragraphdata: string;
  linkarrays: any;
  trackData: any;

  constructor(private route: ActivatedRoute, private staticdata: StaticDataApiService, private commonApiService: CommonApiService,
    private router: Router) { }

  ngOnInit(): void {
    this.route.params.subscribe((param: Params) => {
      this.module = param['id'];
      this.module2 = param['id2'];
      let details = this.staticdata.getModuleByModuleName(param['id']);
      this.header = details?.detailpage?.Heading;

      let trackId = details?.detailpage?.Id;

      this.commonApiService
        .getPromiseResponse({
          apiName: `/api/courses/track/${trackId}/language/${this.module2}`,
          methodType: 'get',
          parameterObject: null,
        })
        .then((result: any) => {
          this.trackData = result;
          console.log(this.trackData);
          
        }).catch((q => {

        }))

      this.paragraphdata = details?.detailpage?.Data;
      this.linkarrays = details?.detailpage.links;
    });
  }

  booklink(courseId) {
    return "/itim-ministry/" + courseId;
  }

}
